module.exports = __webpack_public_path__ + "media/images/benefits_noexpire_inactive-a7913e2c.svg";